import { propOr } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getTableId = (state, tableId) => tableId;

export const root = (state) => state[NAME];

export const getOpenTableRow = createSelector([root, getTableId], (state, tableId) => {
	return propOr({}, tableId)(state);
});
